import React from 'react';
import { Field } from 'formik';
import {
  AccordionItem,
  AccordionItemHeading,
  AccordionItemButton,
  AccordionItemPanel,
} from 'react-accessible-accordion';
import CustomInputWithIcon from '../../common/ui/CustomInputWithIcon';

const AdvanceConfig = () => {
  return (
    <AccordionItem uuid="advance-config">
      <AccordionItemHeading>
        <AccordionItemButton>
          <i className={`wb`}></i>
          <strong>Advance Configuration</strong>
        </AccordionItemButton>
      </AccordionItemHeading>
      <AccordionItemPanel>
        <div className="row">
          <div className="col-md-6">
            <CustomInputWithIcon icon="text">
              <Field
                name="faviconKeyName"
                className="form-control form-control-sm"
                placeholder="Favicon URL"
                title="Enter Favicon URL"
              />
            </CustomInputWithIcon>
          </div>
          <div className="col-md-6">
            <CustomInputWithIcon icon="text">
              <Field
                name="projectLogoKeyName"
                className="form-control form-control-sm"
                placeholder="Logo URL"
                title="Enter Logo URL"
              />
            </CustomInputWithIcon>
          </div>
        </div>
      </AccordionItemPanel>
    </AccordionItem>
  );
};

export default AdvanceConfig;
